import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-dropdown"
export default class extends Controller {
  static targets = ["option", "label"]
  static values = { placeholder: String }

  connect() {
    this.update()
  }

  update() {
    const count = this.optionTargets.filter(checkbox => checkbox.checked).length

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = count > 0 ? `${this.placeholderValue} ${count}` : this.placeholderValue
    }
  }
}
